module.exports = __webpack_public_path__ + "img/bg-4.0c7ead7b.jpg";